import { IProductTexture, ProductTexture } from '../../common/product-texture';
import { DoorRecommendation } from '../../common/door-recommendation';

export interface IStormDoorHandleModel {
    id: string;
    brand: string;
    description: string;
    familyId: string;
    weight: number;
    imageUrl: string;
    auxImageUrls: string[];
    flipbookPages: string[];
    sellingPoints: string[];
    textureVariants: IProductTexture[];
    recommendation: DoorRecommendation;
}


export class StormDoorHandleModel implements IStormDoorHandleModel {
    public id: string = '';
    public brand: string = '';
    public description: string = '';
    public familyId: string = '';
    public weight: number = 0;
    public imageUrl: string = '';
    public auxImageUrls: string[] = [];
    public flipbookPages: string[] = [];
    public sellingPoints: string[] = [];
    public textureVariants: IProductTexture[] = [];
    public recommendation: DoorRecommendation = DoorRecommendation.Standard;
}


